import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import * as React from 'react';

const ConfirmationDialog = ({
  open = false,
  title = '',
  body = '',
  confirm = 'Confirm',
  onConfirm = () => null,
  cancel = 'Cancel',
  onCancel = () => null,
  confirmButtonProps = {}
}) => {
  return (
    <React.Fragment>
      <Dialog open={open} onClose={onCancel} closeAfterTransition={false}>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText>{body}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onCancel}>{cancel}</Button>
          <Button onClick={onConfirm} variant="contained" {...confirmButtonProps}>
            {confirm}
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default ConfirmationDialog;
